module.exports = __webpack_public_path__ + "static/img/specification.22edd76.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/specification.png
// module id = bi+/
// module chunks = 12